.appBar {
  position: absolute;
  /* top: var(--app-dev-banner-h, 0); */
  left: 0;
  right: 0;
  z-index: 1100;
}

:global(:root[data-dev='true']) {
  /**
   * Banner is 24px tall in dev mode (main.tsx sets `data-dev='true'`).
   * Both the banner (dev-banner.module.css) and the chrome
   * (app-chrome.tsx) read this var to size themselves / reserve space.
   * If this is 0px the banner has zero height and disappears entirely.
   */
  --app-dev-banner-h: 24px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  /* Opaque: content scrolling under the bar must not show through. --tuna-palette-layers is translucent. */
  background-color: var(--tuna-surface-default);
  border-bottom: 1px solid var(--tuna-palette-divider);
  box-sizing: border-box;
  z-index: 1;
  color: var(--tuna-palette-text-secondary);
  /* 52px: the bottom hairline lines up with the left sidebar's header row */
  height: 52px;
  gap: 4px;
  align-items: center;
  padding: 0 10px 0 12px;
  overflow: hidden;
}

/* Back: a 32px ghost icon button. `button` outranks the Button primitive's padding and min-width. */
button.backButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-width: 32px;
  height: 32px;
  padding: 0;
  border-radius: var(--tuna-shape-radius-md);
  color: var(--tuna-content-secondary);
  flex-shrink: 0;
}

button.backButton:hover {
  background-color: var(--tuna-palette-action-hover);
  color: var(--tuna-content-primary);
}

button.backButton svg {
  width: 18px;
  height: 18px;
}

/* Small screens and touch: a 44 × 44 target (the icon stays the same size) */
@media (max-width: 899.95px), (pointer: coarse) {
  button.backButton {
    width: 44px;
    min-width: 44px;
    height: 44px;
  }
}

/* One focus ring for the bar's controls: inset, because the bar clips overflow */
.toolbar button:focus-visible,
.toolbar a:focus-visible {
  outline: 2px solid var(--tuna-focus-ring);
  outline-offset: -2px;
}

.placeholder {
  width: 32px;
  flex-shrink: 0;
}

/*
 * The breadcrumb slot never shrinks below the mobile "Show path" button (small IconButton: 24px icon +
 * 2 × 5px padding). When the toolbar is too narrow, the right-side actions overflow instead.
 */
.breadcrumbs {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5);
  flex: 1;
  min-width: 34px;
  overflow: hidden;
}

/* ---- Crumbs: 32px ghost links; the current one in primary text ---- */

.breadcrumbs nav a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  margin: 0;
  padding: 0 8px;
  border-radius: var(--tuna-shape-radius-md);
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-fontSize-sm);
  font-weight: 400;
  text-decoration: none;
}

.breadcrumbs nav a:hover {
  background-color: var(--tuna-palette-action-hover);
  color: var(--tuna-content-primary);
}

.breadcrumbs nav a[aria-current='page'] {
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-fontSize-md);
  font-weight: 550;
}

/* The separators: a muted "/" */
.breadcrumbs nav > span[aria-hidden='true'] {
  margin: 0;
  padding: 0 1px;
  color: var(--tuna-content-secondary);
  opacity: 0.6;
}

@media (pointer: coarse) {
  .breadcrumbs nav a {
    height: 44px;
  }
}
